import React from "react";
import { DashboardSidebar } from "../../layouts";
import { useAuth } from "../../context/AuthContext.jsx";
import { cn } from "../ui";

// The surface is picked here, once, from the role (spec § How a screen is
// converted; DESIGN.md :394): clients dark, advisors and admins light.
function DashboardLayout({ children }) {
  const { role } = useAuth();
  const dark = role === "client";
  return (
    <div className="tw-min-h-screen tw-font-sans rail:tw-flex">
      {/* The column stretches to the page's height so the navy runs to the foot of a
          long page; the rail inside stays sticky at viewport height. */}
      <div className="stars-dark tw-bg-overlay-navy rail:tw-flex-none">
        <DashboardSidebar />
      </div>
      <main
        data-surface={dark ? "dark" : "light"}
        className={cn(
          "tw-min-h-screen tw-min-w-0 tw-flex-1 tw-bg-bg tw-text-text max-rail:tw-pb-16",
          dark && "stars-dark",
        )}
      >
        {children}
      </main>
    </div>
  );
}

export default DashboardLayout;
